import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from "preact/hooks";

export default (collectionGroups) => {
    const { response: { products }, loading, pageType } = useAppState();
    const [ groupedHits, setGroupedHits ] = useState(null);

    useEffect(() => {
        if(!collectionGroups || products.hits?.length < 1) return;
        const currentGroupedHits = [...collectionGroups];
        currentGroupedHits.forEach(group => { group.products = [] });
        products.hits.forEach(hit => {
            const matchedGroup = currentGroupedHits.find(group => hit.tags1.includes(group.tag))
            if(matchedGroup) {
                matchedGroup.products.push(hit);
            } else {
                console.log("TAG NOT FOUND", hit, currentGroupedHits[0].tag, currentGroupedHits[1].tag)
            }
        });
        setGroupedHits(currentGroupedHits);
    }, [ collectionGroups, products ])

    return {
        groupedHits,
    }
}